<template>
    <div v-if="open.isMore">
        {{ open.shortContent }}
        ...
        <a @click="changeState">Show more</a>
    </div>
    <div v-else>
        <code-data :data="data"></code-data>
        <a @click="changeState">Show less</a>
    </div>
</template>

<script>
    import CodeData from "../components/CodeData";
    export default {
        name: "CodeInfo",
        props: ['data'],
        components: {
            'code-data': CodeData,
        },
        data (){
            return {
                maxLength: 300,
                open: {isMore: true}
            }
        },
        created() {
            let obj = this;
            let {data, maxLength} = obj;
            if(typeof data === 'string'){
                obj.open.isMore = data.length > maxLength;
                obj.open.shortContent = data.substring(0, maxLength);
            }

        },
        methods: {
            changeState(){
                this.open.isMore = !this.open.isMore;
            },
        },
    }
</script>

<style>
    .more-link, .less-link {
        cursor: pointer;
        color: blue;
    }
</style>
